//var jQuery = require('jquery');
//require('../web/jquery.cookie');

define(['jquery'], function($) {

    (function ($, window, document, undefined) {
        "use strict";

        var PLUGIN_NAME = "lightShop";
        var PLUGIN_VERSION = "v1.0";

        var DEFAULTS = {
            data: [],
            controlElementPrev: null,
            controlElementNext: null
        };

        /**
         * set basic variables
         * create options and settings for this instance
         * @param element - DOM Element the plugin is applied to
         * @param options - custom settings to be merged with DEFAULTS
         * @constructor
         */
        var LightShop = function (element, options) {
            this.element = element;
            this.$t = $(this.element);

            //this.actualPage = 0;
            this.products = [];
            //this.showing = false;
            this.cookieName = 'TLU_lightShop_cookie';
            this.cookieNameForCount = 'TLU_lightShop_cookie_count';
            this.cart = '.lightShopCart';
            this.cartContainer = '#basket-list';
            this.formContainer = '#orderFormCnt';
            this.priceBox = '.finalPriceBoxCnt';
            this.lang = window.projectConfig.lang;

            this.messages = {
                'cs': {
                    'addToCart': 'Koupit',
                    'inCart': 'V košíku',
                    'addedToCart': 'Zboží bylo přidáno do košíku',
                    'remove': 'Odebrat',
                    'title': 'Název',
                    'variant': 'Varianta',
                    'count': 'Množství',
                    'pricePerPiece': 'Cena / ks',
                    'totalPrice': 'Cena celkem',
                    'withoutVAT': 'Bez DPH:',
                    'withVAT': 'Cena celkem:'
                },
                'en': {
                    'addToCart': 'Buy',
                    'inCart': 'In cart',
                    'addedToCart': 'Item added to cart',
                    'remove': 'Remove',
                    'title': 'Title',
                    'variant': 'Variant',
                    'count': 'Count',
                    'pricePerPiece': 'Price / piece',
                    'totalPrice': 'Total price',
                    'withoutVAT': 'Price without VAT:',
                    'withVAT': 'Total price:'
                },
                'ru': {
                    'addToCart': 'Buy',
                    'inCart': 'In cart',
                    'addedToCart': 'Item added to cart',
                    'remove': 'Remove',
                    'title': 'Title',
                    'variant': 'Variant',
                    'count': 'Count',
                    'pricePerPiece': 'Price / piece',
                    'totalPrice': 'Total price',
                    'withoutVAT': 'Price without VAT:',
                    'withVAT': 'Total price:'
                },
                'zh': {
                    'addToCart': 'Buy',
                    'inCart': 'In cart',
                    'addedToCart': 'Item added to cart',
                    'remove': 'Remove',
                    'title': 'Title',
                    'variant': 'Variant',
                    'count': 'Count',
                    'pricePerPiece': 'Price / piece',
                    'totalPrice': 'Total price',
                    'withoutVAT': 'Price without VAT:',
                    'withVAT': 'Total price:'
                },
                'fr': {
                    'addToCart': 'Buy',
                    'inCart': 'In cart',
                    'addedToCart': 'Item added to cart',
                    'remove': 'Remove',
                    'title': 'Title',
                    'variant': 'Variant',
                    'count': 'Count',
                    'pricePerPiece': 'Price / piece',
                    'totalPrice': 'Total price',
                    'withoutVAT': 'Price without VAT:',
                    'withVAT': 'Total price:'
                },
                'de': {
                    'addToCart': 'Buy',
                    'inCart': 'In cart',
                    'addedToCart': 'Item added to cart',
                    'remove': 'Remove',
                    'title': 'Title',
                    'variant': 'Variant',
                    'count': 'Count',
                    'pricePerPiece': 'Price / piece',
                    'totalPrice': 'Total price',
                    'withoutVAT': 'Price without VAT:',
                    'withVAT': 'Total price:'
                }
            };

            // merge options
            this.options = $.extend(true, {}, DEFAULTS, options);
            this._defaults = DEFAULTS;
            this.initialise();
        };

        /**
         * init function
         */
        LightShop.prototype.initialise = function () {
            this.handleCookie();
            this.loadProducts();
            this.handleListenersForAddToCart();
            this.handleListenersForRemoveFromCart();
            this.handleListenersForFinishOrder();
            this.handleListenersForDeleteCart();
        };

        LightShop.prototype.handleCookie = function () {
            var self = this;
            if (!$.cookie(this.cookieName)) {
                $.cookie(this.cookieName, '', {path: '/'});
            } else {
                var cookieVal = $.cookie(this.cookieName);
            }

            if (!$.cookie(this.cookieNameForCount)) {
                $.cookie(this.cookieNameForCount, '', {path: '/'});
            } else {
                var cookieValForCount = $.cookie(this.cookieNameForCount);
            }
        };

        LightShop.prototype.loadProducts = function () {
            var self = this;
            var productsArr = [];
            $.each(this.options.data, function (i, val) {
                productsArr.push({
                    id: val.id,
                    name: val.name,
                    nameEn: val.nameEn,
                    price: val.price.replace(',', '.'),
                    tags: val.tags
                });
            });

            var cookieVal = $.cookie(this.cookieName);
            var cookieValForCount = $.cookie(this.cookieNameForCount);

            this.renderCart(productsArr, cookieVal, cookieValForCount);
        };


        LightShop.prototype.handleListenersForAddToCart = function () {
            var self = this;

            $(document).on('click', '.lightShopAddToCart', function (e) {
                e.preventDefault();
                var button = this;
                var parent = $(this).parent();
                var id = $(this).data('productId');
                var count = $('.productCount', parent).val();
                var variant = Number($('select', parent).val()) || 9999999;
                self.addToCart(id, count, variant);
                $('.addPopup', parent).remove();
                $(parent).append('<p class="addPopup">' + self.messages[self.lang].addedToCart + '</p>');
                $('.addPopup', parent).fadeIn();
                $(button).attr('disabled', 'disabled');
                var addTimeout = setTimeout(function() {
                    $('.addPopup', parent).fadeOut(400, function() {
                        $(this).remove();
                    });
                    $(button).removeAttr('disabled');
                    clearTimeout(addTimeout);
                }, 2000);
            });
        };

        LightShop.prototype.addToCart = function (id, count, variant) {

            var cookieVal = $.cookie(this.cookieName);
            var cookieValForCount = $.cookie(this.cookieNameForCount);
            if (cookieVal.indexOf(id + '|' + variant) == -1) {
                cookieVal += id;
                cookieVal += '|';
                cookieVal += variant;
                cookieVal += ',';
                cookieValForCount += count;
                cookieValForCount += ',';
                $.cookie(this.cookieName, cookieVal, {path: '/'});
                $.cookie(this.cookieNameForCount, cookieValForCount, {path: '/'});
            } else {
                cookieVal = cookieVal.slice(0, -1);
                if (cookieVal.indexOf(',') > -1) {
                    cookieVal = cookieVal.split(',').map(String);
                } else {
                    cookieVal = cookieVal.split().map(String);
                }
                cookieValForCount = cookieValForCount.slice(0, -1);
                if (cookieValForCount.indexOf(',') > -1) {
                    cookieValForCount = cookieValForCount.split(',').map(Number);
                } else {
                    cookieValForCount = cookieValForCount.split().map(Number);
                }
                var productIndex = cookieVal.indexOf(id + '|' + variant);
                var countAbs = Math.abs(count);
                var actualProductCount = cookieValForCount[productIndex];
                cookieValForCount[productIndex] = actualProductCount + countAbs;

                cookieVal = cookieVal.toString();
                if (cookieVal.length > 0) {
                    cookieVal += ',';
                }
                $.cookie(this.cookieName, cookieVal, {path: '/'});

                cookieValForCount = cookieValForCount.toString();
                if (cookieValForCount.length > 0) {
                    cookieValForCount += ',';
                }
                $.cookie(this.cookieNameForCount, cookieValForCount, {path: '/'});
            }

            this.loadProducts();
        };

        LightShop.prototype.handleListenersForRemoveFromCart = function () {
            var self = this;

            $(document).on('click', '.lightShopRemoveFromCart', function (e) {
                e.preventDefault();
                var id = $(this).data('productId');
                var variant = $(this).data('variant');
                self.removeFromCart(id, variant);
            });
        };

        LightShop.prototype.removeFromCart = function (id, variant) {

            var cookieVal = $.cookie(this.cookieName);
            var cookieValForCount = $.cookie(this.cookieNameForCount);

            if (cookieVal.indexOf(id + '|' + variant) == -1) {

            } else {
                cookieVal = cookieVal.slice(0, -1);
                if (cookieVal.indexOf(',') > -1) {
                    cookieVal = cookieVal.split(',').map(String);
                } else {
                    cookieVal = cookieVal.split().map(String);
                }
                var removingProductIndex = cookieVal.indexOf(id + '|' + variant);
                if (removingProductIndex > -1) {
                    cookieVal.splice(removingProductIndex, 1);
                }

                cookieValForCount = cookieValForCount.slice(0, -1);
                if (cookieValForCount.indexOf(',') > -1) {
                    cookieValForCount = cookieValForCount.split(',').map(Number);
                } else {
                    cookieValForCount = cookieValForCount.split().map(Number);
                }
                //var removingProductIndex = cookieVal.indexOf(id);
                if (removingProductIndex > -1) {
                    cookieValForCount.splice(removingProductIndex, 1);
                }

                cookieVal = cookieVal.toString();
                if (cookieVal.length > 0) {
                    cookieVal += ',';
                }

                cookieValForCount = cookieValForCount.toString();
                if (cookieValForCount.length > 0) {
                    cookieValForCount += ',';
                }

                $.cookie(this.cookieName, cookieVal, {path: '/'});
                $.cookie(this.cookieNameForCount, cookieValForCount, {path: '/'});
            }

            this.loadProducts();
        };

        LightShop.prototype.renderCart = function (productsArr, cookieVal, cookieValForCount) {
            var self = this;

            if ( cookieVal == '' ) {
                //return false;
                $(this.formContainer).hide();
                $('.cartIcon').hide();
            } else {
                $(this.cartContainer).show();
                $(this.formContainer).show();
            }

            cookieVal = cookieVal.slice(0, -1);
            cookieVal = cookieVal.split(',');

            cookieValForCount = cookieValForCount.slice(0, -1);
            cookieValForCount = cookieValForCount.split(',');

            var cartString = '';
            var tags = '';
            var tableHeaderString = '';
            var finalPriceBoxString = '';
            var finalTotalCount = 0;
            var finalTotalCountWithVAT = 0;
            tableHeaderString += '<thead>';
            tableHeaderString += '<tr>';
            //tableHeaderString += '<th>';
            //tableHeaderString += '</th>';
            tableHeaderString += '<th>';
            tableHeaderString += '</th>';
            tableHeaderString += '<th>';
            tableHeaderString += self.messages[self.lang].count;
            tableHeaderString += '</th>';
            tableHeaderString += '<th>';
            tableHeaderString += self.messages[self.lang].pricePerPiece;
            tableHeaderString += '</th>';
            tableHeaderString += '<th>';
            tableHeaderString += self.messages[self.lang].totalPrice;
            tableHeaderString += '</th>';
            tableHeaderString += '<th>';
            tableHeaderString += '</th>';
            tableHeaderString += '</tr>';
            tableHeaderString += '</thead>';

            for (var i = 0; i < cookieVal.length; i++) {
                for (var j = 0; j < productsArr.length; j++) {
                    for (var k in productsArr[j].tags) {
                        if (cookieVal[i] == productsArr[j].id + '|' + productsArr[j].tags[k].id) {
                            if ( i == 0 ) {
                                cartString += tableHeaderString;
                            }
                            cartString += '<tr data-product-id="' + productsArr[j].id + '">';
                            cartString += '<td>';
                            cartString += '<strong>';
                            if ( window.projectConfig.lang == 'cs' ) {
                                cartString += productsArr[j].name;
                            } else {
                                cartString += productsArr[j].nameEn;
                            }
                            cartString += '</strong>';
                            if ( productsArr[j].tags[k].id != 9999999 ) {
                                cartString += ', ';
                                cartString += '<span>';
                                cartString += productsArr[j].tags[k].fullName;
                                cartString += '</span>';
                            }
                            cartString += '</td>';
                            cartString += '<td>';
                            cartString += cookieValForCount[i];
                            cartString += '</td>';
                            cartString += '<td>';
                            if ( window.projectConfig.lang == 'cs' ) {
                                cartString += parseFloat(productsArr[j].price).toFixed(2).replace('.', ',');
                            } else {
                                cartString += parseFloat(productsArr[j].price).toFixed(2);
                            }
                            cartString += ' €';
                            finalTotalCount += Number(productsArr[j].price * cookieValForCount[i]);
                            cartString += '</td>';
                            cartString += '<td>';
                            cartString += '<strong>';
                            if ( window.projectConfig.lang == 'cs' ) {
                                cartString += parseFloat(productsArr[j].price * cookieValForCount[i]).toFixed(2).replace('.', ',');
                            } else {
                                cartString += parseFloat(productsArr[j].price * cookieValForCount[i]).toFixed(2);
                            }
                            cartString += ' €';
                            finalTotalCountWithVAT += Math.round((productsArr[j].price * cookieValForCount[i] * .79) * 100) / 100;
                            cartString += '</strong>';
                            cartString += '</td>';
                            cartString += '<td>';
                            cartString += '<span class="lightShopRemoveFromCart" data-product-id="' + productsArr[j].id + '" data-variant="' + productsArr[j].tags[k].id + '">';
                            cartString += this.messages[this.lang].remove;
                            cartString += '</span>';
                            cartString += '</td>';
                            cartString += '</tr>';
                            //tags = '';
                        }
                    }
                }
            }

            finalPriceBoxString += '';
            finalPriceBoxString += '<div class="finalPriceBox">';
            finalPriceBoxString += '<p>';
            finalPriceBoxString += '<strong>';
            finalPriceBoxString += this.messages[this.lang].withVAT;
            finalPriceBoxString += '</strong>';
            finalPriceBoxString += '<strong class="finalTotalPrice">';
            finalPriceBoxString += ' ';
            if ( window.projectConfig.lang == 'cs' ) {
                finalPriceBoxString += parseFloat(finalTotalCount).toFixed(2).replace('.', ',');
            } else {
                finalPriceBoxString += parseFloat(finalTotalCount).toFixed(2);
            }
            finalPriceBoxString += ' ';
            finalPriceBoxString += '€';
            finalPriceBoxString += '</strong>';
            finalPriceBoxString += '</p>';
            finalPriceBoxString += '</div>';

            if (cartString.length == 0) {
                $(this.cartContainer).hide();
            } else {
                $(this.cartContainer).show();
            }

            /*if ((cartString.length > 0) && ($('#orderForm').length > 0)) {
                this.hideDefaultTextAndForm();
            } else if ((cartString.length == 0) && ($('#orderForm').length > 0)) {
                this.showDefaultTextAndForm();
            }*/
            $(this.cart).html(cartString);

            if ($(this.priceBox).length > 0) {
                $(this.priceBox).html(finalPriceBoxString);

            } else {
                var finalPriceBoxStringExtended = '';
                finalPriceBoxStringExtended += '<div class="finalPriceBoxCnt clearfix col-xs-12">';
                finalPriceBoxStringExtended += finalPriceBoxString;
                finalPriceBoxStringExtended += '</div>';
                $(this.cartContainer).append(finalPriceBoxStringExtended);
            }

            if ( cookieVal == '' ) {
                $('.cartIcon .amount').text(0);
            } else {
                $('.cartIcon .amount').text(i);
            }


        };

        LightShop.prototype.handleListenersForFinishOrder = function () {
            var self = this;

            $(document).on('submit', '#orderForm', function (e) {
                self.finishOrder();
            });
        };

        LightShop.prototype.finishOrder = function () {
            var self = this;
            //dodělat přidání dat z cookie k emailu

            var productsArr = [];

          $.each(this.options.data, function (i, val) {
            productsArr.push({
              id: val.id,
              name: val.name,
              nameEn: val.nameEn,
              price: val.price.replace(',', '.'),
              tags: val.tags
            });
          });

            var cookieVal = $.cookie(this.cookieName);
            var cookieValForCount = $.cookie(this.cookieNameForCount);

            cookieVal = cookieVal.slice(0, -1);
            if (cookieVal.indexOf(',') > -1) {
                cookieVal = cookieVal.split(',').map(String);
            } else {
                cookieVal = cookieVal.split().map(String);
            }

            cookieValForCount = cookieValForCount.slice(0, -1);
            if (cookieValForCount.indexOf(',') > -1) {
                cookieValForCount = cookieValForCount.split(',').map(Number);
            } else {
                cookieValForCount = cookieValForCount.split().map(Number);
            }

            var cartStringForMail = '';
            var textCartStringForMail = '';
            var tags = '';
            var tableHeaderStringForMail = '';
            var textHeaderStringForMail = '';
            var finalPriceBoxStringForMail = '';
            var finalTextPriceBoxStringForMail = '';
            var finalTotalCount = 0;
            var finalTotalCountWithVAT = 0;
            tableHeaderStringForMail += '<thead>';
            tableHeaderStringForMail += '<tr>';
            tableHeaderStringForMail += '<th style="text-align: left; padding: 0 0 8px 0; border-bottom: 1px solid #000;">';
            tableHeaderStringForMail += self.messages[self.lang].title;
            tableHeaderStringForMail += '</th>';
            tableHeaderStringForMail += '<th style="padding: 0 0 8px 0; border-bottom: 1px solid #000;">';
            tableHeaderStringForMail += self.messages[self.lang].count;
            tableHeaderStringForMail += '</th>';
            tableHeaderStringForMail += '<th style="padding: 0 0 8px 0; border-bottom: 1px solid #000;">';
            tableHeaderStringForMail += self.messages[self.lang].pricePerPiece;
            tableHeaderStringForMail += '</th>';
            tableHeaderStringForMail += '<th style="text-align: right; padding: 0 0 8px 0; border-bottom: 1px solid #000;">';
            tableHeaderStringForMail += self.messages[self.lang].totalPrice;
            tableHeaderStringForMail += '</th>';
            tableHeaderStringForMail += '</tr>';
            tableHeaderStringForMail += '</thead>';

            textHeaderStringForMail += self.messages[self.lang].title;
            textHeaderStringForMail += ', ';
            textHeaderStringForMail += self.messages[self.lang].variant;
            textHeaderStringForMail += ', ';
            textHeaderStringForMail += self.messages[self.lang].count;
            textHeaderStringForMail += ', ';
            textHeaderStringForMail += self.messages[self.lang].pricePerPiece;
            textHeaderStringForMail += ', ';
            textHeaderStringForMail += self.messages[self.lang].totalPrice;
            textHeaderStringForMail += '\n';


            for (var m = 0; m < cookieVal.length; m++) {
                for (var n = 0; n < productsArr.length; n++) {
                    for (var o in productsArr[n].tags) {
                        if (cookieVal[m] == productsArr[n].id + '|' + productsArr[n].tags[o].id) {
                            if ( m == 0 ) {
                                cartStringForMail += tableHeaderStringForMail;
                                textCartStringForMail += textHeaderStringForMail;
                            }
                            cartStringForMail += '<tr>';
                            cartStringForMail += '<td style="text-align: left; padding: 4px 0 4px 0;">';
                            cartStringForMail += '<strong>';
                            if ( window.projectConfig.lang == 'cs' ) {
                                cartStringForMail += productsArr[n].name;
                                textCartStringForMail += productsArr[n].name;
                            } else {
                                cartStringForMail += productsArr[n].nameEn;
                                textCartStringForMail += productsArr[n].nameEn;
                            }
                            cartStringForMail += '</strong>';
                            if ( productsArr[n].tags[o].id != 9999999 ) {
                                cartStringForMail += ', ';
                                cartStringForMail += '<span>';
                                cartStringForMail += productsArr[n].tags[o].fullName;
                                cartStringForMail += '</span>';
                            }
                            cartStringForMail += '</td>';
                            cartStringForMail += '<td style=" padding: 4px 0 4px 0;">';
                            cartStringForMail += cookieValForCount[m];
                            cartStringForMail += '</td>';
                            cartStringForMail += '<td style=" padding: 4px 0 4px 0;">';
                            cartStringForMail += parseFloat(productsArr[n].price).toFixed(2).replace('.', ',');
                            cartStringForMail += ' €';
                            finalTotalCount += Number(productsArr[n].price * cookieValForCount[m]);
                            cartStringForMail += '</td>';
                            cartStringForMail += '<td style="text-align: right; padding: 4px 0 4px 0;">';
                            cartStringForMail += '<strong>';
                            cartStringForMail += parseFloat(productsArr[n].price * cookieValForCount[m]).toFixed(2).replace('.', ',');
                            finalTotalCountWithVAT += Math.round((productsArr[n].price * cookieValForCount[m] * .79) * 100) / 100;
                            cartStringForMail += '</strong>';
                            cartStringForMail += '</td>';
                            cartStringForMail += '</tr>';

                            if ( productsArr[n].tags[o].id != 9999999 ) {
                                textCartStringForMail += ', ';
                                textCartStringForMail += productsArr[n].tags[o].fullName;
                            }
                            textCartStringForMail += ', ';
                            textCartStringForMail += parseFloat(cookieValForCount[m]).toFixed(2).replace('.', ',');
                            textCartStringForMail += ', ';
                            textCartStringForMail += productsArr[n].price;
                            textCartStringForMail += ' €';
                            //finalTotalCount += Number(productsArr[n].price * cookieValForCount[m]);
                            textCartStringForMail += ', ';
                            textCartStringForMail += parseFloat(productsArr[n].price * cookieValForCount[m]).toFixed(2).replace('.', ',');
                            textCartStringForMail += ' €';
                            textCartStringForMail += ', ';
                            textCartStringForMail += Math.round((productsArr[n].price * cookieValForCount[m] * .79) * 100) / 100;
                            textCartStringForMail += ' €';
                            textCartStringForMail += '\n';
                        }
                    }
                }
            }

            finalPriceBoxStringForMail += '';
            finalPriceBoxStringForMail += cartStringForMail;
            finalPriceBoxStringForMail += '<tr>';
            finalPriceBoxStringForMail += '<td style="border-top: 1px solid #000;">';
            finalPriceBoxStringForMail += '</td>';
            finalPriceBoxStringForMail += '<td style="border-top: 1px solid #000;">';
            finalPriceBoxStringForMail += '</td>';
            finalPriceBoxStringForMail += '<td style="border-top: 1px solid #000;">';
            finalPriceBoxStringForMail += '</td>';
            finalPriceBoxStringForMail += '<td style="text-align: right; padding: 8px 0 4px 0; border-top: 1px solid #000;">';
            finalPriceBoxStringForMail += '<strong>';
            finalPriceBoxStringForMail += this.messages[this.lang].withVAT;
            finalPriceBoxStringForMail += '</strong>';
            finalPriceBoxStringForMail += '<strong class="finalTotalPrice">';
            finalPriceBoxStringForMail += ' ';
            finalPriceBoxStringForMail += parseFloat(finalTotalCount).toFixed(2).replace('.', ',');
            finalPriceBoxStringForMail += ' ';
            finalPriceBoxStringForMail += '€';
            finalPriceBoxStringForMail += '</strong>';
            finalPriceBoxStringForMail += '</td>';
            finalPriceBoxStringForMail += '</tr>';

            finalTextPriceBoxStringForMail += '';
            finalTextPriceBoxStringForMail += textCartStringForMail;
            finalTextPriceBoxStringForMail += this.messages[this.lang].withoutVAT;
            finalTextPriceBoxStringForMail += ' ';
            finalTextPriceBoxStringForMail += parseFloat(finalTotalCountWithVAT).toFixed(2).replace('.', ',');
            finalTextPriceBoxStringForMail += '€';
            finalTextPriceBoxStringForMail += ', ';
            finalTextPriceBoxStringForMail += this.messages[this.lang].withVAT;
            finalTextPriceBoxStringForMail += ' ';
            finalTextPriceBoxStringForMail += parseFloat(finalTotalCount).toFixed(2).replace('.', ',');
            finalTextPriceBoxStringForMail += ' ';
            finalTextPriceBoxStringForMail += '€';

            $('#productsSum').val(finalPriceBoxStringForMail);
            $('#productsSumText').val(finalTextPriceBoxStringForMail);
        };

        LightShop.prototype.handleListenersForDeleteCart = function () {
            var self = this;

            $(document).on('TLU_lightShop_deleteCart', function () {
                self.deleteCart();
            });
        };

        LightShop.prototype.deleteCart = function () {
            var self = this;

            var cookieVal = $.cookie(this.cookieName);

            $.cookie(this.cookieName, '', {path: '/'});
            $.cookie(this.cookieNameForCount, '', {path: '/'});

            this.loadProducts();
        };

        /**
         * decide, which methods will be "public"
         */
        var API = {
            //method: PluginSkeleton.prototype.method
            //loadMarkers: GoogleMap.prototype.loadMarkers
        };

        /**
         * plugin go live
         * @param value - first param - decides, which action shall be executed
         *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
         *    if string && in API object - run method named as this value with all args[index > 0]
         * @return {*}
         */
        $.fn[PLUGIN_NAME] = function (value) {
            var args = arguments;

            return this.each(function () {
                var $this = $(this);

                // get plugin instance
                var plugin = $this.data('plugin_' + PLUGIN_NAME);

                // if there's not, create one
                if (!plugin) {
                    plugin = new LightShop(this, value);
                    $this.data('plugin_' + PLUGIN_NAME, plugin);
                }
                // if there is and first parameter is in predefined API methods, call it with rest of params
                else if (API[value]) {
                    plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
                }
            });
        };

        /**
         * setDefaults with $.pluginSkeleton.setDefaults();
         */
        $[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
        $[PLUGIN_NAME].setDefaults = function (newOptions) {
            DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
        };
    })(jQuery, window, document);
});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.lightShop.js